module.exports = __webpack_public_path__ + "static/media/horse.9429e6f8.jpg";